// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetJobQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetJobQuery = { __typename?: 'Query' } & {
  job: Types.Maybe<
    { __typename?: 'Job' } & Pick<Types.Job, 'id' | 'name'> & {
        defaultEpmMasterFunctionality: Types.Maybe<
          { __typename?: 'EpmMasterFunctionality' } & Pick<Types.EpmMasterFunctionality, 'id' | 'name'>
        >;
        definitions: Array<{ __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'content'>>;
      }
  >;
};

export const GetJobDocument = /*#__PURE__*/ gql`
    query getJob($id: ID!) {
  job(id: $id) {
    id
    name
    defaultEpmMasterFunctionality {
      id
      name
    }
    definitions {
      languageCode
      content
    }
  }
}
    `;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables> &
    ({ variables: GetJobQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
}
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
}
// @ts-expect-error
export function useGetJobSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetJobQuery, GetJobQueryVariables>;
export function useGetJobSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetJobQuery | undefined, GetJobQueryVariables>;
export function useGetJobSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
}
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobSuspenseQueryHookResult = ReturnType<typeof useGetJobSuspenseQuery>;
